export default function Splat({
  color,
  position,
}: {
  color: string | undefined
  position: 'left' | 'right' | undefined
}): React.ReactElement | null {
  if (position === 'left') {
    return (
      <svg
        className="absolute top-28 left-2"
        fill="none"
        height="80"
        viewBox="0 0 49 80"
        width="49"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5313 0.718053C9.51734 0.574657 8.65082 1.29383 8.86889 2.0948C9.61575 4.83684 8.54731 10.1073 6.28269 17.3664C4.03608 24.5681 0.157691 33.8605 0.136564 39.9256C0.0858113 54.4954 8.79377 51.2954 8.01718 41.9906C7.69838 38.1729 9.7095 33.6671 11.524 34.5158C14.4539 35.8857 11.9261 50.8823 10.409 63C7.53725 85.9376 27.5827 82.6017 23.4233 65.1607C18.4661 44.3741 30.1677 36.8923 33.0209 48.4298C35.8742 59.9669 50.0483 57.3243 46.2706 36.4241C44.88 28.7317 44.529 11.0513 48.5945 4.37003C49.0672 3.59283 48.3641 2.69174 47.2788 2.70552C40.9735 2.78556 24.9011 2.74988 10.5313 0.718053Z"
          fill={color}
        />
      </svg>
    )
  }

  if (position === 'right') {
    return (
      <svg
        className="absolute top-28 right-3"
        fill="none"
        height="79"
        viewBox="0 0 44 79"
        width="44"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M41.1097 3.34141C42.0368 3.34104 42.6634 4.15835 42.3125 4.90653C41.1107 7.46779 41.0205 12.7339 41.5993 20.0955C42.1733 27.399 43.7824 36.9569 42.6074 42.8513C39.7848 57.0112 32.6953 52.7097 35.2151 43.7775C36.2491 40.1127 35.3532 35.4603 33.5777 36.0361C30.7108 36.9655 30 51.8793 28.9597 63.8581C26.9909 86.5328 9.87788 80.5461 16.9978 64.174C25.4834 44.6613 16.5829 35.7904 11.7828 46.6068C6.98282 57.4229 -5.06189 52.914 2.40048 33.1294C5.14722 25.8475 8.93825 8.72112 6.64937 1.67402C6.38328 0.854284 7.18392 0.0753082 8.14331 0.237393C13.7169 1.179 27.9716 3.34636 41.1097 3.34141Z"
          fill={color}
        />
      </svg>
    )
  }

  return null
}
